import { inject, Injectable } from '@angular/core';

import { SCHEMA_VALIDATION_ENABLED } from '@blaze-shared/platform-data-access';
import { type BlazeSchema, validateData } from '@blaze-shared/schema-domain';

/**
 * Validates data against a schema, honouring the build's validation switch.
 *
 * Element events are validated by `SchemaValidationService` in `runtime/engine/feature`,
 * which needs the element definitions; this is the part of the job that needs nothing but
 * the schema and the switch.
 */
@Injectable({ providedIn: 'root' })
export class SchemaDataValidator {
  private readonly validationEnabled = inject(SCHEMA_VALIDATION_ENABLED);

  /** @returns `true` when the data matches the schema, or when validation is switched off. */
  validateData(schema: BlazeSchema | null, data: unknown): boolean {
    if (!this.validationEnabled) {
      return true;
    }

    if (schema === null) {
      // If the schema is null, we expect no data
      return data === undefined;
    }

    try {
      return validateData(schema, data);
    } catch (error) {
      console.error(`[Schema Validation] Data Validation error`, { error, schema, data });
    }

    return false;
  }
}
